import { ReactNode } from "react";

import styled from "styled-components";

const FieldContent = styled.div<{ $colSpan?: number }>`
  margin: auto 0px;
  padding: 0px 20px 5px 0px;
  max-width: ${({ $colSpan }: { $colSpan?: number }) =>
    $colSpan ? `${$colSpan * 350 + ($colSpan - 1) * 100}px` : "350px"};
  text-overflow: ellipsis;
  grid-column: span
    ${({ $colSpan }: { $colSpan?: number }) =>
      $colSpan ? 2 * $colSpan - 1 : 1};
`;

const FieldLabel = styled(FieldContent)`
  font-weight: bold;
`;

const HeaderContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(
    auto-fit,
    minmax(max-content, 100px) minmax(max-content, 350px)
  );
`;

const HeaderDetailField = ({
  children,
  label,
  colSpan,
}: {
  children?: ReactNode;
  label: ReactNode;
  colSpan?: number;
}) => {
  return (
    <>
      <FieldLabel>{label}</FieldLabel>
      <FieldContent $colSpan={colSpan}>{children}</FieldContent>
    </>
  );
};

const HeaderDetail = ({ children }: { children?: ReactNode }) => {
  return <HeaderContainer>{children}</HeaderContainer>;
};

export default Object.assign(HeaderDetail, {
  Field: HeaderDetailField,
});
